import { useEffect } from 'react';

import { useInviteClientTrigger } from '@/features/invite-client/store/store';
import { usePilotSelfPlanIntakeForm } from '@/shared/hooks/use-active-pilot-program';

export function useSelfTestIntakeFormDialogState() {
  const { isSelfTestIntakeFormOpen, clearInviteClientParams } = useInviteClientTrigger();
  // Not held by the NYL advisor-only period: planning for yourself is not client use.
  const isAvailable = !!usePilotSelfPlanIntakeForm();

  useEffect(() => {
    if (isSelfTestIntakeFormOpen && !isAvailable) clearInviteClientParams();
  }, [clearInviteClientParams, isAvailable, isSelfTestIntakeFormOpen]);

  return {
    isAvailable,
    isOpen: isSelfTestIntakeFormOpen && isAvailable,
    clearInviteClientParams,
  };
}
